export default __webpack_public_path__ + "static/media/pexels-math-331684.af87fd0d.jpg";